import React from "react"
import PropTypes from "prop-types"

const CardHeader = props => {
  const {
    titleSize,
    indentHeader,
    header: { noBottomMargin, title, subtitle },
    button,
    className,
    noBottomBorder,
    icon,
    filterButton
  } = props

  const cardTitle =
    titleSize === "h1" ? (
      <h1 className={noBottomMargin || ""}>{title}</h1>
    ) : titleSize === "h2" ? (
      <h2 className={noBottomMargin || ""}>{title}</h2>
    ) : (
      <h3 className={noBottomMargin || ""}>{title}</h3>
    )

  let classNameHeader = ""
  if (indentHeader) classNameHeader += " card-header"
  if (button) classNameHeader += " button"
  if (className) classNameHeader += ` ${className}`
  if (noBottomBorder) classNameHeader += ` ${noBottomBorder}`

  return (
    <div className={classNameHeader}>
      <div className="d-flex flex-row align-items-baseline">
        <div>
          {icon ? (
            <div className="d-flex align-items-center">
              {icon}
              {cardTitle}
            </div>
          ) : (
            cardTitle
          )}
          {subtitle}
        </div>
        {filterButton}
      </div>
      {button}
    </div>
  )
}
export default CardHeader

CardHeader.propTypes = {
  titleSize: PropTypes.string,
  indentHeader: PropTypes.bool,
  header: PropTypes.shape({
    noBottomMargin: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string
  }),
  button: PropTypes.bool,
  className: PropTypes.string,
  noBottomBorder: PropTypes.string.isRequired,
  icon: PropTypes.string,
  filterButton: PropTypes.string
}

CardHeader.defaultProps = {
  titleSize: "h3",
  indentHeader: false,
  header: {
    noBottomMargin: null,
    subtitle: null
  },
  button: false,
  className: null,
  icon: null,
  filterButton: null
}
